import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, imgUrl } from "@/lib/api";
import Lightbox from "@/components/Lightbox";
import ShareButton, { usePageMeta } from "@/components/Share";
import NotFound from "@/pages/NotFound";

export default function GalleryDetail() {
  const { slug } = useParams();
  const [g, setG] = useState(undefined);
  const [open, setOpen] = useState(-1);

  useEffect(() => {
    api.get(`/public/galleries/${slug}`).then(({ data }) => setG(data)).catch(() => setG(null));
  }, [slug]);
  usePageMeta(g?.title, g?.description);
  if (g === undefined) return <p className="max-w-7xl mx-auto px-8 pt-20 text-sm text-[#5a665e]">Loading…</p>;
  if (g === null) return <NotFound />;
  const images = g.images || [];

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-10 sm:pt-14" data-testid="gallery-detail-page">
      <div className="flex items-center justify-between gap-4">
        <Link to="/galleries" className="inline-flex items-center gap-2 text-sm text-[#5a665e] hover:text-[#1f402b]" data-testid="gallery-back-link"><ArrowLeft size={14} /> All galleries</Link>
        <ShareButton kind="galleries" slug={g.slug} title={g.title} />
      </div>
      <div className="mt-8 grid lg:grid-cols-12 gap-8">
        <div className="lg:col-span-7">
          <p className="eyebrow">{g.location}</p>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#1a261f]" data-testid="gallery-title">{g.title}</h1>
        </div>
        <p className="lg:col-span-5 lg:pt-10 text-[#5a665e] leading-relaxed">{g.description}</p>
      </div>
      {images.length === 0 ? (
        <p className="mt-16 text-[#5a665e]">Photographs coming soon.</p>
      ) : (
        <div className="mt-14 columns-1 sm:columns-2 lg:columns-3 gap-6 [&>*]:mb-6">
          {images.map((img, i) => (
            <button key={img.id || i} onClick={() => setOpen(i)} className="block w-full text-left img-zoom break-inside-avoid" data-testid={`gallery-image-${i}`}>
              <div className="overflow-hidden bg-[#f4f0ea]">
                <img src={imgUrl(img.url)} alt={img.caption || g.title} className="w-full h-auto" loading="lazy" />
              </div>
              {img.caption && <p className="mt-2 font-mono-k text-[11px] text-[#5a665e]">{img.caption}</p>}
            </button>
          ))}
        </div>
      )}
      <p className="mt-10 font-mono-k text-[11px] text-[#5a665e] border-t border-[#e2dcd4] pt-5">
        All images are non-sexual and published with consent. To request removal, <Link to="/contact" className="underline">contact us</Link>.
      </p>
      {open >= 0 && <Lightbox images={images} index={open} onIndex={setOpen} onClose={() => setOpen(-1)} />}
    </div>
  );
}
